export const ACCOUNT_GLOBAL = 'global'

export const COMMON_UI_INSTRUMENTATION_ID = 'G-E9RTKDJZ8W'

export const TELEM_FUNC_NORMAL = 'gtag'
export const TELEM_FUNC_COMMON_UI = 'gtagCommon'

export const TELEM_PARAM_ACCOUNT_ID = 'accountId'
export const TELEM_PARAM_APP_NAME = 'appName'
export const TELEM_PARAM_ENVIRONMENT = 'environment'
export const TELEM_PARAM_USER_TYPE = 'userType'
export const TELEM_PARAM_USER_ID = 'userId'

export const USER_TYPE_INTERNAL = 'internal'
export const USER_TYPE_EXTERNAL = 'external'

export const TELEM_EVENT_ENTERED_APP = 'entered_app'
export const TELEM_EVENT_CLICKED_MENU = 'clicked_menu'

// these restrictions are imposed by Google
export const INVALID_EVENT_NAME_REGEX = /[- ]/
export const MAX_EVENT_NAME_LENGTH = 40
export const MAX_EVENT_PARAMETERS = 25

export const DEFAULT_EVENTS_TO_WIRE = ['click']
